<div class="graph-wrapper">
    <div class="header">
        <h4 class="ellipses d-flex">Delivered Quantity ({{unit}}) vs Cost %
            &nbsp;
            <div [popover]="popTemplate" triggers="mouseenter:mouseleave" container="body" placement="bottom">

                <img src="../../../assets/images/icn-info.svg" alt="">
            </div>
        </h4>
        <div class="minimise" mat-dialog-close></div>
    </div>
    <div #graphComboDiv width="100%" height="100%" class="bar-chart" id="graphComboDiv"></div>
</div>
<ng-template #popTemplate>
    <div class="mb-15">Daily/Monthly trend of Delivered Quantity against Cost % at the Line level</div>

    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost % =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                total waste cost generated on day/month

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                total waste cost of the line for the selected period
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>